<template>
  <div
    ref="product_nav"
    v-show="show"
    :style="{ bottom: `-${product_Height}px` }"
    class="box  pi-flex"
  >
    <div class="nav_left" style="background: #f5f5f5 !important">
      <template v-for="(p_nav, index) in product_list">
        <div
          class="nav_left_item"
          :key="`father${index}`"
          @click.stop="product_idx = index"
          :style="product_idx == index && 'color: #E92131 !important;'"
        >
          {{ p_nav.name }}
        </div>
      </template>
    </div>

    <div class="nav_right" style="background: #fff !important">
      <template v-for="(p_sub_nav, idx) in product_list[product_idx].sub">
        <div :key="`child${idx}`" class="child">
          <span
            class="pi-fz-18 pi-text-left nav_right_title"
            style="color: #222222; white-space: nowrap; font-weight: bold"
          >
            {{ p_sub_nav.name }}</span
          >
          <div>
            <template
              v-for="(p_sub_child_nav, child_idx) in product_list[product_idx]
                .sub[idx].sub"
            >
              <div
                class="pi-fz-14 pi-text-left pi-lh-48"
                style="color: #222222; white-space: nowrap; font-weight: 400"
                :key="`p_sub_child_nav${child_idx}`"
                @click.stop="$emit('change',false);openUrl(p_sub_child_nav.link)"
              >
                {{ p_sub_child_nav.name }}
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ProductList from "./index";
export default {
  data() {
    return {
      product_Height: 320,
      product_idx: 0,
      product_list: ProductList,
    };
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(idx){

    },
    openUrl(url) {
      console.log(url)
      this.$router.push(url).catch((failure) => {
        console.log(failure);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.nav_right {
  display: flex;
  padding: 36px 42px;
  .child{
     margin-left: 50px;

  }
  .child:first-child{
    margin-left: 0 !important;
  }
  &_title{
    margin-bottom: 21px;
    display: block;
    padding-bottom: 19px;
    border-bottom: 2px solid #eee;
  }
}
.nav_left {
  padding: 34px;
  width: 232px;
  white-space: nowrap;
  &_item {
    text-align: left;
    margin-bottom: 20px;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
    color: #222222 !important;
    line-height: 32px;
    font-weight: bold;
    &-c {
      color: #e92131 !important;
    }
  }
}
.box {
  position: absolute;
  left: -30px;
  background-color: #fff !important;

  min-width: 937px;
  height: 330px;
  background: #ffffff;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/components/page-header/nav.vue